import React,{Component} from 'react'
import {
    BrowserRouter as Router,
    // Switch,
    // Route,
    Link,
    // useParams
  } from "react-router-dom";
// import { Link } from "react-router-dom";
import contact_icon_1 from '../img/contact-icon-1.svg';
import contact_icon_2 from '../img/contact-icon-2.svg';
// import contact_icon_3 from '../img/contact-icon-3.svg';
import sunyimg from '../img/suny.png';
import Client from "../contentful";
import qatarsvg from '../img/qatar.svg'
import logo from '../img/logo.svg'
import ussvg from '../img/us.svg'
import { Navbar,Nav,DropdownButton,NavDropdown , Dropdown , NavItem,NavLink, ButtonGroup ,Button} from 'react-bootstrap'

import { LightgalleryProvider } from "react-lightgallery";
import { LightgalleryItem } from "react-lightgallery";
// import Video  from '../video/sunyvideo.mp4'
import * as contentful from 'contentful';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { Player } from 'video-react';
import "../../node_modules/video-react/dist/video-react.css"
import "../../node_modules/lightgallery.js/dist/css/lightgallery.css";


export default class Partneruniversitiessuny extends Component {
 
   
    constructor(props){
        super(props);
        this.state = {
            // isLoaded:false,

           banner:"",
           images:[],
           table:[],
           video:"",
           sunyimage:""
        }
        this.formatData = this.formatData.bind(this)
    }

    

    formatData(items) {
        let tempItems = items.map(item => {
          let id = item.sys.id;
          
          let banner = item.fields.banner?.fields?.file?.url
          let images =  item.fields.gallery;
          let table = item.fields.table.items
          let video = item.fields.video
          let sunyimage = item.fields.sunyimage?.fields?.file?.url
        
          this.setState({
              banner: banner,
              images: images,
              table: table,
              video:video,
              sunyimage:sunyimage
             
          })
        });
        return tempItems;
        console.log(items)
  
      }
      
      componentDidMount() {
          Client.getEntries({
              content_type : "partnerUniversitySuny"
            })
            .then(response=>{
              console.log(response.items)
              this.formatData(response.items)
              const associatesText = response.items[0].fields?.associatesText
              document.getElementById('rich-text-body').innerHTML = documentToHtmlString(associatesText)

              const thePowerOfSunyText = response.items[0].fields?.thePowerOfSunyText
              document.getElementById('rich-text-body2').innerHTML = documentToHtmlString(thePowerOfSunyText)

              const leadingTheWayText = response.items[0].fields?.leadingTheWayText
              document.getElementById('rich-text-body3').innerHTML = documentToHtmlString(leadingTheWayText)

              const getStartedAtSunyAdirondackText = response.items[0].fields?.getStartedAtSunyAdirondackText
              document.getElementById('rich-text-body4').innerHTML = documentToHtmlString(getStartedAtSunyAdirondackText)
            })
  
            
  
      }
        

    render() {
      function mouseenter0() {
        
        const button = document.getElementById('dropdown-basic0')
        button.click()
      }

      function mouseleave0(){
        const button = document.getElementById('dropdown-basic0')
        button.click()
      }
      function mouseenter1() {
        
        const button = document.getElementById('dropdown-basic1')
        button.click()
      }

      function mouseleave1(){
        const button = document.getElementById('dropdown-basic1')
        button.click()
      }

      function mouseenter2() {
        
        const button = document.getElementById('dropdown-basic2')
        button.click()
      }

      function mouseleave2(){
        const button = document.getElementById('dropdown-basic2')
        button.click()
      }
      function mouseenter3() {
        
        const button = document.getElementById('dropdown-basic3')
        button.click()
      }

      function mouseleave3(){
        const button = document.getElementById('dropdown-basic3')
        button.click()
      }
      function mouseenter4() {
        
        const button = document.getElementById('dropdown-basic4')
        button.click()
      }

      function mouseleave4(){
        const button = document.getElementById('dropdown-basic4')
        button.click()
      }
        return(
            <div>
           
           <Navbar bg="light" collapseOnSelect expand="lg" >
  <Navbar.Brand > <Link to="/" >
        <img className="logo horizontal-logo" src={logo} alt="logo"  style={{width:"150px",  marginLeft:"5rem",marginRight:"10px"}} />
      </Link></Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
    <Nav className="mr-auto">

      <Nav.Link >
        <Button variant="Info" style={{
          padding: "0px",
          marginTop: "0.4rem",
          marginRight: "1rem",
          marginLeft:"10px" }}>
            <Link to="/"  style={{color: "#424242"}}>
              <b> Home </b>
            </Link>
        </Button>
      </Nav.Link>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter0} onMouseLeave={mouseleave0}> 
        
       <Dropdown>
  <Dropdown.Toggle variant="bg-light" id="dropdown-basic0" >
  <Link to="/aboutus" style={{color: "#424242"}}>
             <b>About </b>
          </Link>
  </Dropdown.Toggle>

  <Dropdown.Menu>
    <Dropdown.Item ><Link to="/presidentsbio" style={{color: "black"}}>President’s Bio</Link></Dropdown.Item>
    <Dropdown.Item ><Link to="/coreteam" style={{color: "black"}} >Core Team</Link></Dropdown.Item>
    <Dropdown.Item ><Link to="/organization_structure" style={{color: "black"}}> Organization Structure </Link></Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter1} onMouseLeave={mouseleave1}> 
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic1" >
        <Link to="/liveclassroomtechnology" style={{color: "#424242"}}>
            <b>Technology </b>
            
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/liveclassroomtechnology" style={{color: "black"}}>Live Classroom Technology</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/location" style={{color: "black"}}>Our Location</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/technology_partner" style={{color: "black"}}>Technology Partner</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter2} onMouseLeave={mouseleave2}>
         
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic2" >
        <Link to="/academics" style={{color: "#424242"}}>
           <b>Academics </b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/academics" style={{color: "black"}}>Degrees & Programs</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/admissions" style={{color: "black"}}>Admissions</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/transfers" style={{color: "black"}}>Transfers</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/students_services" style={{color: "black"}}> Student Services</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter3} onMouseLeave={mouseleave3}>
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic3" >
        <Link to="/aspirecampus" style={{color: "#424242"}}>
            <b>Aspire Campus</b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/aspirezone" style={{color: "black"}}>Aspire Zone</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/aspireacademy" style={{color: "black"}}>Aspire Academy</Link></Dropdown.Item>
        {/* <Dropdown.Item ><Link to="/students_services" style={{color: "black"}}> Student Services</Link></Dropdown.Item> */}
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter4} onMouseLeave={mouseleave4}>
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic4" >
        <Link to="/partner_universities" style={{color: "#424242"}}>
           <b> Partner Universities</b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/partner_university_suny" style={{color: "black"}}>SUNY Adirondack</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/partner_university_south_carolina" style={{color: "black"}}>University of South Carolina</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/partner_university_arkansas" style={{color: "black"}}> Arkansas State University</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <Nav.Link>
      <Button variant="Info" style={{
    padding: "0px",
    marginTop: "0.3rem",
    marginLeft:"10px"}}>
      <Link to="/contactus" style={{color: "#424242"}}>
        <b>Contact Us</b>
        </Link>
        </Button>
      </Nav.Link>


      <li class="nav-item dropdown">
        <Button variant="Info">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown3" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <img src={ussvg} />
          </a>
          </Button>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown3">
            <a class="dropdown-item" href=""><img src={qatarsvg}/></a>
          </div>
          
        </li>
     
    </Nav>
   
  </Navbar.Collapse>
</Navbar> 

           <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
  <div class="carousel-inner carousel-slider">
    <div class="carousel-item active">	
      <img class="d-block w-100" src={this.state.banner} alt="First slide" />
      <div class="carousel-caption carousel-caption-center">
	    <h1>SUNY <br/> </h1>
	  </div>
    </div>
  </div>
</div>

<div class="container mt-5 mb-5">
  <div class="col-lg-12 mb-5">
    
  </div>
  <div class="row">
      <div class="col-lg-4">
        <div class="shadow p-25 technology height-100">
          <h4 class="text-center mt-2">Associate Degrees</h4>



          {/* <p>As a member of the State University of New York, SUNY Adirondack is committed to offering a series of courses that comprise the general education components for numerous US colleges and universities, including those in Qatar. The courses are specifically chosen to satisfy a broad set of requirements that serve as the foundation of many bachelor’s degree programs with whom SUNY Adirondack has transfer agreements. They can also be applied to associate’s degrees at SUNY Adirondack itself such as the Associate in Liberal Arts: Humanities and Social Sciences, Associate in Liberal Arts: Math and Sciences, Associate in Applied Science - Cybersecurity and Associate in Applied Science - Mechatronics.</p>

  <a  href="https://www.sunyadkqatar.com/" target="_blank">
       <p class="list-inline-item color-2 mt-4"><i class="fa fa-arrow-right mr-1"></i><strong>SUNY ADK Global </strong></p> 
    </a> */}
    <p><div id="rich-text-body"></div> </p>


        </div>
      </div>
      <div class="col-lg-4">
        <div class="shadow p-25 technology height-100">
          <h4 class="text-center mt-2">The Power of SUNY</h4>
          <p><div id="rich-text-body2"></div></p>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="shadow p-25 technology height-100">
          <h4 class="text-center mt-2">Leading The Way</h4>
          {/* <p>SUNY Adirondack is a Two-year Community College with an Emphasis on Community.</p>
          <p> <strong>With more than 30 unique academic programs, SUNY Adirondack is a Leader in the Region’s Workforce Development, Preparing the Next Generation of Leaders for a Bright Future.</strong> </p> */}


  {/* <a  href="https://www.sunyadkqatar.com/" target="_blank">
       <p class="list-inline-item color-2 mt-4"><i class="fa fa-arrow-right mr-1"></i><strong>About SUNY</strong></p> 
    </a> */}
<p><div id="rich-text-body3"></div></p>

          
        </div>
      </div>

  </div>
</div>

<div class="container mt-5 mb-5">
  <img src={this.state.sunyimage} />
</div>

<div class="container">
<div class="table-responsive table-section">
      <table class="table text-center">
        <tbody>
          <tr >
        
            <td  width="30%"><b>Adirondack Course Number </b></td>
            <td  width="30%"><b>Adirondack Course Name</b></td>
            <td width="30%" ><b>SUNY General Education Requirement</b></td>
          </tr>

          
            {
this.state.table.map(item=>(
            <tr>
            <td width="30%">{item?.AdirondackCourseNumber}</td>
            <td width="30%">{item?.AdirondackCourseName}</td>
           
            <td width="30%">{item?.SUNYGeneralEducationRequirement}</td>
            </tr>
))
    }
         

       </tbody>
      </table>
    </div>
    </div>

<div class="bg-1 p-t-50 p-b-50">
<div class="container">

     <div class="col-lg-10 usc">  
     <Player
      playsInline
     
      src={ this.state.video?.fields?.file?.url }
    />
     </div>



  <h4 class="mt-5 mb-5 font-w-600">Get Started At SUNY ADIRONDACK</h4>


<p><div id="rich-text-body4"> </div></p>



</div>

</div>


<div class="container mb-5 mt-5">
    <h2 class="mt-5 mb-3 font-w-600">Gallery</h2>
        <div class="home">
        <div class="aspire-campus">
            <ul class="lightgallery list-unstyled row">
            <LightgalleryProvider>
            {
					this.state.images.map(item => (

                <li class="col-xs-6 col-sm-4 col-md-3 pointer" >
                  <LightgalleryItem group="any" src={item?.fields?.file?.url}>
                    <a  >
                        <img class="img-responsive pointer" src={item?.fields?.file?.url} />
                        
                    </a>
                    </LightgalleryItem>
                </li>
                    ))
                    }
                    
                {/* <li class="col-xs-6 col-sm-4 col-md-3" data-src="img/partner-universities/suny/2.jpg">
                    <a href="">
                         <img class="img-responsive" src="img/partner-universities/suny/thumb-img-2.jpg" />
                    </a>
                </li>
                <li class="col-xs-6 col-sm-4 col-md-3" data-src="img/partner-universities/suny/3.jpg">
                    <a href="">
                        <img class="img-responsive" src="img/partner-universities/suny/thumb-img-3.jpg" />
                    </a>
                </li>
                <li class="col-xs-6 col-sm-4 col-md-3" data-src="img/partner-universities/suny/4.jpg">
                    <a href="">
                        <img class="img-responsive" src="img/partner-universities/suny/thumb-img-4.jpg" />
                    </a>
                </li> */}
                </LightgalleryProvider>
            </ul>
        </div>
      </div>

        {/* <div class="home">
        <div class="aspire-campus">
            <ul class="lightgallery list-unstyled row">
                <li class="col-xs-6 col-sm-4 col-md-3" data-src="img/partner-universities/suny/5.jpg">
                    <a href="">
                        <img class="img-responsive" src="img/partner-universities/suny/thumb-img-5.jpg" />
                    </a>
                </li>
                <li class="col-xs-6 col-sm-4 col-md-3" data-src="img/partner-universities/suny/6.jpg">
                    <a href="">
                         <img class="img-responsive" src="img/partner-universities/suny/thumb-img-6.jpg" />
                    </a>
                </li>
                <li class="col-xs-6 col-sm-4 col-md-3" data-src="img/partner-universities/suny/7.jpg">
                    <a href="">
                        <img class="img-responsive" src="img/partner-universities/suny/thumb-img-7.jpg" />
                    </a>
                </li>
                <li class="col-xs-6 col-sm-4 col-md-3" data-src="img/partner-universities/suny/8.jpg">
                    <a href="">
                        <img class="img-responsive" src="img/partner-universities/suny/thumb-img-8.jpg" />
                    </a>
                </li>
            </ul>
        </div>
      </div> */}

</div>









            </div>
            
        )
    }
}